var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import Typography from '@material-ui/core/Typography';
import { withStyles, createStyles } from '@material-ui/core';
var styles = function (theme) {
    return createStyles({
        italic: {
            fontStyle: 'italic',
        },
        'fw-normal': {
            fontWeight: 'normal',
        },
        'fw-bold': {
            fontWeight: 'bold',
        },
        'fw-bolder': {
            fontWeight: 'bolder',
        },
        'fw-lighter': {
            fontWeight: 'lighter',
        },
        'fw-100': {
            fontWeight: 100,
        },
        'fw-200': {
            fontWeight: 200,
        },
        'fw-300': {
            fontWeight: 300,
        },
        'fw-400': {
            fontWeight: 400,
        },
        'fw-500': {
            fontWeight: 500,
        },
        'fw-600': {
            fontWeight: 600,
        },
        'fw-700': {
            fontWeight: 700,
        },
        'fw-800': {
            fontWeight: 800,
        },
        'fw-900': {
            fontWeight: 900,
        },
        'fw-inherit': {
            fontWeight: 'inherit',
        },
        'fw-initial': {
            fontWeight: 'initial',
        },
        'fw-unset': {
            fontWeight: 'unset',
        },
        'kind-muted': {
            color: theme.palette.grey[500],
        },
        'kind-price': {
            color: theme.palette.secondary.main,
        },
        'kind-inline': {
            display: 'contents',
        },
    });
};
var Text = function (_a) {
    var _b;
    var children = _a.children, classes = _a.classes, className = _a.className, kind = _a.kind, fw = _a.fw, italic = _a.italic, props = __rest(_a, ["children", "classes", "className", "kind", "fw", "italic"]);
    return (React.createElement(Typography, __assign({}, props, { className: cx(className, (_b = {},
            _b[classes["fw-" + fw]] = Boolean(fw),
            _b[classes["kind-" + kind]] = Boolean(kind),
            _b[classes.italic] = italic,
            _b)) }), children));
};
export default withStyles(styles)(Text);
//# sourceMappingURL=index.js.map